<section>
  <div class="tabs">
    <div class="tab mt-10 j-c-s">
      <input type="checkbox" attr.id="chck{{ currParentRowIndex }}" />
      <label class="tab-label" for="chck{{ currParentRowIndex }}">
        <p class="m-0">Discussions</p>
      </label>

      <div class="tab-content">
        <div class="divider"></div>

        <!--timeline  -->
        <section class="d-flex j-c-s timeline-box" *ngFor="let timeline of timelineDetails; let i = index">
          <div class="d-flex a-center timeline-box-item">
            <div class="line"></div>
            <h2 class="user-info"> {{ timeline?.shortName }} </h2>
          </div>
          <div class="timeline-content">
            <div class="d-flex j-c-s a-center">
              <div class="timeline-left-content">
                <small>
                  <b>{{ timeline.createdby }}<br>{{ timeline.groupName }}</b>
                </small><br/>
                <small>
                  {{timeline?.createdDate | date: dateFormatWithTime}}
                </small>
              </div>
              <div class="timeline-right-content">
                <span>
                  <small>
                    <b>Comment Added:</b>
                  </small><br/>
                  <small class="comment-display"> {{ timeline.commentsAdded }} </small>
                </span>
              </div>
            </div>
          </div>    
        </section>
        
      </div>
    </div>
  </div>
</section>
